export const PUBLIC_VIEW_ID_PATTERN = /^(TRPCT|TRPTT|TTD|TT|TTF)[A-Z0-9]+$/i;

export const getCompanyFromAccountUniqueId = (accountUniqueId = '') => {
    const normalizedId =
        typeof accountUniqueId === 'string' ? accountUniqueId.trim().toUpperCase() : '';

    if (normalizedId.startsWith('TRPCT')) return 'Peak Capital Trading';
    if (normalizedId.startsWith('TRPTT')) return 'Bear Bull Traders';
    if (
        normalizedId.startsWith('TTD') ||
        normalizedId.startsWith('TTF') ||
        normalizedId.startsWith('TT')
    ) {
        return 'Trading Terminal';
    }

    return null;
};
